import type { TrendArrowIconProps } from './UpIcon8px';

export const DownIcon8px = ({ color = '#8A8A8A' }: TrendArrowIconProps = {}) => {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_18114_1160)">
        <path d="M1 1L6.5 6.5M6.5 6.5V1.5M6.5 6.5H1.5" stroke={color} strokeWidth="1.5" />
      </g>
      <defs>
        <clipPath id="clip0_18114_1160">
          <rect width="8" height="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
